var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import styled from 'styled-components';
export var Search = styled.svg.attrs(function (props) {
  return {
    children: props.title != null ? [React.createElement("title", {
      key: "Search-title"
    }, props.title), React.createElement("path", {
      d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
      key: "k0"
    })] : [React.createElement("path", {
      d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
      key: "k0"
    })],
    viewBox: '0 0 24 24',
    height: props.height !== undefined ? props.height : props.size,
    width: props.width !== undefined ? props.width : props.size,
    // @ts-ignore - aria is not always defined on SVG in React TypeScript types
    'aria-hidden': props.title == null ? 'true' : undefined,
    focusable: 'false',
    role: props.title != null ? 'img' : undefined,
    "fill": "currentColor"
  };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"])));
Search.displayName = 'Search';
export var SearchDimensions = {
  height: 24,
  width: 24
};
var templateObject_1;